import { Routes } from '@angular/router';

export const AUTH_ROUTES: Routes = [
  {
    path: '',
    redirectTo: '',
    pathMatch: 'full',
  },
  {
    path: '',
    loadComponent: () => import('./components/login/login.component').then(c => c.LoginComponent),
  },
  {
    path: 'register',
    loadComponent: () =>
      import('./components/register/register.component').then(c => c.RegisterComponent),
  },
  {
    path: 'confirm',
    loadComponent: () =>
      import('./components/registration-confirm/registration-confirm.component').then(
        c => c.RegistrationConfirmComponent,
      ),
  },
  {
    path: 'recovery',
    loadComponent: () =>
      import('./components/recovery/recovery.component').then(c => c.RecoveryComponent),
  },
];
